import React from 'react';
import login from '../images/login.png';
import EnvironmentVariables from '../utils/EnvironmentVariables';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import { StyledCard } from '../utils/StyledComponents';
import creatorConsoleImage from '../images/creatorConsole.png'; // Placeholder - needs to be created

const Home = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const { idToken, handleLogout } = useAuth();
    const navigate = useNavigate();

    const onLogout = () => {
        handleLogout();
        navigate('/');
    };

    return (
        <Container fluid className="mt-5 ps-md-5">
            <Row className="justify-content-center">
                <Col xs={12} className="text-center">
                    <Image 
                        src={login} 
                        alt="Login"
                        fluid
                    />
                </Col>
            </Row>

            {!code && (
                <Row className="justify-content-center mt-3">
                    <Col xs={12} sm={8} md={6} lg={4} className="text-center">
                        {idToken ? (
                            <Button 
                                variant="outline-light"
                                onClick={onLogout}
                            >
                                Logout
                            </Button>
                        ) : (
                            <>
                                <p>Welcome ! Sign up or login to use app functionalities.</p>
                                <p>
                                    By signing up, you agree to our <Link to="/privacy" className="text-white">Privacy Notice</Link>
                                </p>
                                <Button 
                                    variant="outline-light"
                                    onClick={() => window.location.href = EnvironmentVariables.AuthURL}
                                >
                                    Sign up/login
                                </Button>
                            </>
                        )}
                    </Col>
                </Row>
            )}
            
            

            <Row className="justify-content-center mt-4">
                <Col xs={12} md={6}>
                    <StyledCard>
                        <h2 className="text-center mb-4">For Music Fans 🎧</h2>
                        <Row className="mb-4">
                            <Col xs={12} md={4} className="text-center">
 {/*                                <Image 
                                    src="/images/viewer-step1.png" 
                                    alt="Join Session"
                                    fluid
                                    className="mb-3"
                                /> */}
                                <h5 style={{ color: 'var(--bs-primary)' }}>Join the Party</h5>
                                <p>Pick a live session and dive into the music. Connect with creators and other fans in real-time!</p>
                            </Col>
                            <Col xs={12} md={4} className="text-center">
{/*                                 <Image 
                                    src="/images/viewer-step2.png" 
                                    alt="Share Emotions"
                                    fluid
                                    className="mb-3"
                                /> */}
                                <h5 style={{ color: 'var(--bs-primary)' }}>Share Your Groove</h5>
                                <p>Turn on your camera to share your reactions. Nod, smile, and let the music move you. Earn points while you vibe!</p>
                            </Col>
                            <Col xs={12} md={4} className="text-center">
 {/*                                <Image 
                                    src="/images/viewer-step3.png" 
                                    alt="Request Songs"
                                    fluid
                                    className="mb-3"
                                /> */}
                                <h5 style={{ color: 'var(--bs-primary)' }}>Make It Your Show</h5>
                                <p>Use your points to request songs and climb the leaderboard. Shape the visual content and playlist with your musical taste!</p>
                            </Col>
                        </Row>
                    </StyledCard>
                </Col>
            </Row>

            <Row className="justify-content-center mt-5">
                <Col xs={12} md={6}>
                    <StyledCard>
                        <h2 className="text-center mb-4">For Music Creators 🎵</h2>
                        <Row className="mb-4">
                            <Col xs={12} md={4} className="text-center">
{/*                                 <Image 
                                    src="/images/creator-step1.png" 
                                    alt="Create Session"
                                    fluid
                                    className="mb-3"
                                /> */}
                                <h5 style={{ color: 'var(--bs-primary)' }}>Create Your Space</h5>
                                <p>Start a session to connect with your audience. Set up your streaming links and customize your experience.</p>
                            </Col>
                            
                            <Col xs={12} md={4} className="text-center">
{/*                                 <Image 
                                    src="/images/creator-step3.png" 
                                    alt="Engage Audience"
                                    fluid
                                    className="mb-3"
                                /> */}
                                <h5 style={{ color: 'var(--bs-primary)' }}>Feel & Share the Vibe</h5>
                                <p>Watch real-time reactions and emotions from your audience. See who's grooving to your beats! Insert an overlay in your stream so participants can see reactions. </p>
                            </Col>
                            <Col xs={12} md={4} className="text-center">
{/*                                 <Image 
                                    src="/images/creator-step2.png" 
                                    alt="Manage Playlist"
                                    fluid
                                    className="mb-3"
                                /> */}
                                <h5 style={{ color: 'var(--bs-primary)' }}>Build Your Show</h5>
                                <p>You can create your song list and let viewers make requests using their earned points. Keep the music flowing!</p>
                            </Col>
                        </Row>
                    </StyledCard>
                </Col>
            </Row>
        </Container>
    );
}

export default Home;